import { useInfiniteQuery } from '@tanstack/react-query'
import { listConversations } from '../../../data/statsAssistant'
import { UserFriendlyError } from '../../../model/Error'
import { statsAssistantKeys } from './statsAssistant.keys'

interface UseConversationsParams {
  search?: string
  enabled?: boolean
}

export const useConversations = ({ search, enabled = true }: UseConversationsParams = {}) =>
  useInfiniteQuery({
    queryKey: statsAssistantKeys.conversations(search),
    queryFn: async ({ pageParam }) => {
      const { data, ok } = await listConversations(pageParam, search)
      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          'Impossible de charger l’historique',
          'Une erreur technique s’est produite',
        )
      }
      return data
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.reduce((count, page) => count + page.items.length, 0)
      return loadedCount < lastPage.total ? allPages.length + 1 : undefined
    },
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
